import { useMemo } from 'react';
import useGetHeadquartersOperators from './useGetHeadquartersOperators';

const useHeadquartersOptions = (excludeId?: string) => {
  const { headquarters, isLoading } = useGetHeadquartersOperators({
    paginated: {
      page: 1,
      pageSize: 100,
    },
  });

  const filteredHeadquarters = useMemo(
    () =>
      excludeId
        ? headquarters.filter((operator) => operator.id !== excludeId)
        : headquarters,
    [headquarters, excludeId]
  );

  const options = useMemo(
    () =>
      filteredHeadquarters.map((operator) => ({
        value: operator.id,
        label: operator.fullName,
      })),
    [filteredHeadquarters]
  );

  return {
    headquarters: filteredHeadquarters,
    options,
    isLoading,
  };
};

export default useHeadquartersOptions;
